<template>
    <div>
        <MenuAccount/>
        <AccountSetting/>
    </div>
</template>

<script>

import MenuAccount from '@/components/menuadmin/account/accountheader/MenuAccount.vue'
import AccountSetting from '@/components/menuadmin/account/accountsetting/AccountSetting.vue'
export default {
    name:'accountSetting',
    components:{
        MenuAccount,
        AccountSetting,
    },
}
</script>